module.exports = __webpack_public_path__ + "img/1480133539.3479005d.jpg";